import {Dialog} from '@headlessui/react'
import React, {useImperativeHandle, useState} from 'react'
import Text from '../text/Text'

interface IProps {
    children?: React.ReactNode
    className?: string
    onClose?: () => void
    title?: string
}

const WizModal = ({className, children, onClose, title}: IProps, ref: any) => {
    const [isOpen, setIsOpen] = useState(false)

    useImperativeHandle(ref, () => ({
        show: () => {
            showModal()
        },
        close: () => {
            closeModal()
        },
    }))

    const closeModal = () => {
        setIsOpen(false)
        onClose && onClose()
    }

    const showModal = () => {
        setIsOpen(true)
    }

    return (
        <>
            <Dialog as="div" open={isOpen} className="relative z-modal" onClose={closeModal}>
                <div className="fixed inset-0 overflow-y-auto">
                    <div className={'w-full h-full bg-black bg-opacity-40 absolute'} />
                    <div className={`flex min-h-full items-center justify-center text-center`}>
                        <Dialog.Panel
                            className={`transform overflow-y-auto rounded-[5px] space-y-[20px] bg-white py-[20px] px-[30px] text-left shadow-normal w-[520px] min-h-[150px] sm:w-full sm:max-w-[340px]  ${className}`}>
                            <Text className={'text-h2'}>{title}</Text>
                            <div>{children}</div>
                        </Dialog.Panel>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default React.forwardRef(WizModal)
